import React from 'react';
import AdminPanel from './pages/AdminPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Wheel from './pages/WheelPage';
import Login from "./pages/LoginPage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WinnersPage from './pages/WinnersPage';
import BackgroundSettingsPage from './pages/BackgroundSettingsPage';



function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Wheel />} />
          <Route path="/quaythuong" element={<Wheel />} />
          <Route path="/nguoitrungthuong" element={<WinnersPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/giaithuong" element={<AdminPanel />} />
          <Route path="/caidat-nen" element={<BackgroundSettingsPage />} />
        </Routes>
        <ToastContainer />
      </Router>
    </div>
  );
}

export default App;
